import React, { useState, useRef, useEffect } from 'react';
import Footer from '../components/Footer';

// Per-category accent colors
const CATEGORY_COLORS = {
  'Wedding Events':               '#3D6B35',
  'Dining or Drinks with a View': '#C2410C',
  'Casual Dining & Bars':         '#7C3AED',
  'Shopping':                     '#0369A1',
  'Outdoors & Activities':        '#D97706',
};

// Filter chips shown above the map
const FILTER_OPTIONS = [
  { key: 'Wedding Events',         label: 'Wedding Events'     },
  { key: 'Dining or Drinks with a View',     label: 'Dining or Drinks with a View' },
  { key: 'Casual Dining & Bars',   label: 'Casual & Bars'      },
  { key: 'Shopping',               label: 'Shopping'           },
  { key: 'Outdoors & Activities',  label: 'Outdoors'           },
];

const RAW_CATEGORIES = [
  {
    title: 'Wedding Events',
    items: [
      {
        name: 'Welcome Party — LaPlaya Beach Club',
        desc: 'Thursday evening welcome party on the Gulf.',
        address: '9891 Gulf Shore Dr, Naples, FL 34108',
        coords: [26.260797344822144, -81.82451663660828],
        url: 'https://www.laplayaresort.com/',
      },
      {
        name: 'Saint William Catholic Church',
        desc: 'Ceremony venue.',
        address: '601 Seagate Dr, Naples, FL 34108',
        coords: [26.21226086216945, -81.80449491792189],
        url: 'https://www.saintwilliam.org/',
      },
      {
        name: 'Naples Beach Club, A Four Seasons Resort',
        desc: 'Reception venue.',
        address: '801 Gulf Shore Blvd N, Naples, FL 34102',
        coords: [26.156681656017195, -81.80894070615062],
        url: 'https://www.naplesbeachclub.com/',
      },
    ],
  },
  {
    title: 'Dining or Drinks with a View',
    items: [
      {
        name: 'The Turtle Club',
        desc: 'An iconic Naples institution serving fresh seafood steps from the Gulf. A local legend.',
        address: '9225 Gulf Shore Dr N, Naples, FL 34108',
        coords: [26.2550488, -81.8232749],
        url: 'https://www.turtleclubnaples.com/',
      },
      {
        name: 'Gumbo Limbo',
        desc: "The Ritz-Carlton's signature restaurant with stunning Gulf views and fresh seafood.",
        address: '280 Vanderbilt Beach Rd, Naples, FL 34108',
        coords: [26.25162, -81.82264],
        url: 'https://www.ritzcarlton.com/en/hotels/naples/dining',
      },
      {
        name: 'Baleen',
        desc: 'Waterfront dining at LaPlaya — fresh seafood with gorgeous Gulf-front terrace seating.',
        address: '9891 Gulf Shore Dr N, Naples, FL 34108',
        coords: [26.260953, -81.824108],
        url: 'https://www.laplayaresort.com/dining/baleen/',
      },
      {
        name: 'Sunset Bar',
        desc: 'The Naples Beach Club Four Seasons beachside bar — the best seat in the house for a Gulf sunset.',
        address: '851 Gulf Shore Blvd N, Naples, FL 34102',
        coords: [26.1570, -81.8083],
        url: 'https://www.fourseasons.com/naplesbeachclub/dining/lounges/sunset-bar/',
      },
      {
        name: "Buzz's Lighthouse",
        desc: 'Casual waterfront spot with great seafood, cold drinks, and gorgeous bay views.',
        address: '9180 Gulf Shore Dr, Naples, FL 34108',
        coords: [26.2551237, -81.8223137],
        url: 'https://www.buzzslighthouse.com/',
      },
      {
        name: 'The Dock at Crayton Cove',
        desc: 'A Naples landmark on the bay — fresh fish, cold drinks, and perfect sunset views.',
        address: '845 12th Ave S, Naples, FL 34102',
        coords: [26.132988, -81.794056],
        url: 'https://www.dockcraytoncove.com/',
      },
      {
        name: 'Perry Hotel Rooftop',
        desc: "Naples' only rooftop bar — panoramic views over the Naples skyline and bay.",
        address: '12155 Tamiami Trl N, Naples, FL 34110',
        coords: [26.280636, -81.8025076],
        url: 'https://www.perryhotelnaples.com/naples-fl-hotel-dining',
      },
    ],
  },
  {
    title: 'Casual Dining & Bars',
    items: [
      {
        name: 'La Trattoria',
        desc: 'Beloved neighborhood Italian with homemade pasta and a warm, convivial atmosphere.',
        address: '878 5th Ave S, Naples, FL 34102',
        coords: [26.1415, -81.7951],
        url: 'https://www.latrattorianaples.com/',
      },
      {
        name: 'Brooklyn Dough',
        desc: 'New York–style breakfast bagel spot with fresh-baked bagels, egg sandwiches, and great coffee.',
        address: '935 3rd Ave N, Naples, FL 34102',
        coords: [26.1509, -81.7954],
        url: 'https://brooklyndough.com/',
      },
      {
        name: 'Celebration Park',
        desc: 'A festive outdoor food hall with rotating food trucks, craft beer, and live entertainment on the bay.',
        address: '2880 Becca Ave, Naples, FL 34112',
        coords: [26.1261, -81.7708],
        url: 'https://celebrationparknaples.com/',
      },
      {
        name: 'North Naples Country Club',
        desc: 'Low-key neighborhood sports dive bar dishing out American-Southern comfort eats plus beer & cocktails.',
        address: '10095 Tamiami Trl N, Naples, FL 34108',
        coords: [26.26353996070745, -81.80172032433258],
        url: 'https://nncountryclub.com/',
      },
      {
        name: 'Irish Times Pub',
        desc: 'Classic Irish pub atmosphere with live music, cold pints, and welcoming regulars.',
        address: '8939 Tamiami Trl N, Naples, FL 34108',
        coords: [26.2515, -81.8031],
        url: 'https://www.irishtimesnaples.com/',
      },
      {
        name: 'Tacos & Tequila',
        desc: 'Fun, festive cantina with handcrafted margaritas, street tacos, and a lively patio scene.',
        address: '8971 Tamiami Trl N, Naples, FL 34108',
        coords: [26.2517, -81.8033],
        url: 'https://www.tacosandtequilanaples.com/',
      },
    ],
  },
  {
    title: 'Shopping',
    items: [
      {
        name: 'Fifth Avenue South',
        desc: "Naples' premier shopping and dining district lined with boutiques, galleries, and cafés.",
        address: 'Fifth Ave S, Naples, FL 34102',
        coords: [26.1417, -81.7964],
        url: 'https://www.fifthavenuesouth.com/',
      },
      {
        name: 'Third Street South',
        desc: 'A charming neighborhood of art galleries, wine bars, and local shops.',
        address: '1167 3rd St S, Naples, FL 34102',
        coords: [26.1329, -81.8017],
        url: 'https://thirdstreetsouth.com/',
      },
      {
        name: 'Waterside Shops',
        desc: 'Upscale open-air shopping center with designer boutiques and fine dining.',
        address: '5415 Tamiami Trl N, Naples, FL 34108',
        coords: [26.213635541477775, -81.80262706156175],
        url: 'https://www.watersideshops.com/',
      },
      {
        name: 'Miromar Outlets',
        desc: 'Large outdoor outlet mall with over 140 stores offering great deals.',
        address: '10801 Corkscrew Rd, Estero, FL 33928',
        coords: [26.43787225166225, -81.7720244835271],
        url: 'https://www.miromaroutlets.com/',
      },
    ],
  },
  {
    title: 'Outdoors & Activities',
    items: [
      {
        name: 'Vanderbilt Beach',
        desc: 'Steps from the Naples Beach Club — a pristine Gulf beach perfect for sunsets.',
        address: '100 Vanderbilt Beach Rd, Naples, FL 34108',
        coords: [26.25381494416235, -81.82334935839029],
        url: 'https://www.collierparks.com/collier_park/vanderbilt-beach-park/',
      },
      {
        name: 'Naples Beach & Pier',
        desc: 'The iconic Naples pier stretching into the Gulf. Great for watching sunrises and local fishermen.',
        address: '12th Ave S & Gulf Shore Blvd S, Naples, FL 34102',
        coords: [26.1252, -81.8056],
        url: 'https://www.naplesgov.com/parksrec/park/naples-pier/',
      },
      {
        name: 'Naples Zoo',
        desc: 'A gorgeous zoo nestled within a historic botanical garden. Great for families.',
        address: '1590 Goodlette-Frank Rd, Naples, FL 34102',
        coords: [26.1681, -81.7906],
        url: 'https://www.napleszoo.org/',
      },
      {
        name: 'Pelican Bay Community Courts',
        desc: 'Six well-maintained outdoor pickleball courts in a beautiful Pelican Bay setting. Open to the public.',
        address: '764 Vanderbilt Beach Rd, Naples, FL 34108',
        coords: [26.250901871703192, -81.80747513430042],
        url: 'https://www.pelicanbaycourts.com/',
      },
      {
        name: 'Tiburón Golf Club',
        desc: "Home of the PGA Tour's QBE Shootout — two 18-hole Greg Norman-designed courses set among natural wetlands.",
        address: '2620 Tiburón Drive, Naples, FL 34109',
        coords: [26.247984879053064, -81.76425502469672],
        url: 'https://www.tiburonnaples.com/',
      },
      {
        name: 'Salt Leaf Golf Preserve',
        desc: 'A stunning Nicklaus Design course in Bonita Springs with native landscape just north of Naples.',
        address: '23001 Saltleaf Blvd, Bonita Springs, FL 34134',
        coords: [26.406474618122292, -81.83476423379763],
        url: 'https://saltleafgolf.com/',
      },
    ],
  },
];

// Assign global sequential numbers once at module level
let n = 0;
const CATEGORIES = RAW_CATEGORIES.map(cat => ({
  ...cat,
  color: CATEGORY_COLORS[cat.title],
  items: cat.items.map(item => ({ ...item, num: ++n, categoryTitle: cat.title })),
}));

const MAP_ITEMS = CATEGORIES.flatMap(cat =>
  cat.items.filter(i => i.coords).map(i => ({ ...i, color: cat.color }))
);

// ── Vanilla-Leaflet map (no react-leaflet) ───────────────────────────────────
function NaplesMap({ activeNum, onMarkerClick, activeFilter, routeGeometry, routeEndpoints }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const markersRef = useRef({});
  const routeLayerRef = useRef(null);

  // Initialize map once
  useEffect(() => {
    if (mapRef.current) return;
    const L = window.L;
    if (!L) return;

    const map = L.map(containerRef.current, {
      center: [26.21, -81.80],
      zoom: 11,
      zoomControl: true,
    });

    // OpenStreetMap's own tile server — CARTO's basemaps began requiring an API
    // key in Oct 2026 (tiles rendered "API KEY REQUIRED"), so we no longer use them.
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19,
    }).addTo(map);

    MAP_ITEMS.forEach(item => {
      const icon = makeIcon(item.num, item.color, false);
      const marker = L.marker(item.coords, { icon })
        .addTo(map);
      marker.on('click', () => onMarkerClick(item.num));
      markersRef.current[item.num] = { marker, item };
    });

    mapRef.current = map;
    return () => { map.remove(); mapRef.current = null; };
  }, []); // eslint-disable-line

  // Show/hide markers when filter changes
  useEffect(() => {
    const L = window.L;
    if (!L || !mapRef.current) return;
    Object.values(markersRef.current).forEach(({ marker, item }) => {
      const visible = !activeFilter || item.categoryTitle === activeFilter;
      if (visible && !mapRef.current.hasLayer(marker)) {
        marker.addTo(mapRef.current);
      } else if (!visible && mapRef.current.hasLayer(marker)) {
        marker.remove();
      }
    });
  }, [activeFilter]);

  // Update marker icons when activeNum changes
  useEffect(() => {
    const L = window.L;
    if (!L || !mapRef.current) return;
    Object.values(markersRef.current).forEach(({ marker, item }) => {
      const isActive = item.num === activeNum;
      const isEndpoint = routeEndpoints && (routeEndpoints[0] === item.num || routeEndpoints[1] === item.num);

      if (routeEndpoints) {
        // During directions: highlight endpoints, hide others via opacity
        marker.setIcon(makeIcon(item.num, item.color, isEndpoint, false, !isEndpoint));
        marker.setOpacity(isEndpoint ? 1 : 0);
      } else {
        // Normal mode: dim non-selected when one is active
        marker.setOpacity(1);
        const dimmed = activeNum != null && !isActive;
        marker.setIcon(makeIcon(item.num, item.color, isActive, dimmed, false));
      }
    });
    if (activeNum != null && markersRef.current[activeNum]) {
      const { marker } = markersRef.current[activeNum];
      mapRef.current.flyTo(marker.getLatLng(), Math.max(mapRef.current.getZoom(), 14), { duration: 0.6 });
    }
  }, [activeNum, routeEndpoints]);

  // Draw / clear route polyline
  useEffect(() => {
    const L = window.L;
    if (!L || !mapRef.current) return;
    if (routeLayerRef.current) {
      mapRef.current.removeLayer(routeLayerRef.current);
      routeLayerRef.current = null;
    }
    if (!routeGeometry) return;
    try {
      const layer = L.geoJSON(routeGeometry, {
        style: { color: '#3D6B35', weight: 5, opacity: 0.75 },
      }).addTo(mapRef.current);
      routeLayerRef.current = layer;
      mapRef.current.fitBounds(layer.getBounds(), { padding: [50, 50] });
    } catch (e) {
      // Leaflet may throw in certain rendering contexts; route info still shows
      console.warn('Route drawing failed:', e);
    }
  }, [routeGeometry]);

  return <div ref={containerRef} style={{ height: '100%', width: '100%' }} />;
}

function makeIcon(num, color, active, dimmed, hidden) {
  const size = active ? 34 : dimmed ? 26 : 28;
  const bg = dimmed ? '#ccc' : color;
  const textColor = dimmed ? '#999' : '#fff';
  const shadow = active ? '0 2px 8px rgba(0,0,0,0.45)' : dimmed ? '0 1px 3px rgba(0,0,0,0.1)' : '0 2px 8px rgba(0,0,0,0.28)';
  const fontSize = active ? 13 : dimmed ? 10 : 11;
  return window.L.divIcon({
    className: '',
    html: `<div style="background:${bg};color:${textColor};width:${size}px;height:${size}px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-family:Montserrat,sans-serif;font-size:${fontSize}px;font-weight:700;border:2.5px solid white;box-shadow:${shadow};transition:all 0.2s ease;">${num}</div>`,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
    popupAnchor: [0, -size / 2 - 4],
  });
}
// ────────────────────────────────────────────────────────────────────────────

// Inject Leaflet CSS + JS once
function useLeaflet(onReady) {
  useEffect(() => {
    if (window.L) { onReady(); return; }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    document.head.appendChild(link);

    const script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.onload = onReady;
    document.head.appendChild(script);
  }, []); // eslint-disable-line
}

// ── OSRM routing helper ──────────────────────────────────────────────────────
async function fetchOSRMRoute(fromCoords, toCoords) {
  // OSRM expects lng,lat — our data is [lat, lng]
  const url = `https://router.project-osrm.org/route/v1/driving/${fromCoords[1]},${fromCoords[0]};${toCoords[1]},${toCoords[0]}?overview=full&geometries=geojson`;
  const res = await fetch(url);
  if (!res.ok) throw new Error('Routing service unavailable');
  const data = await res.json();
  if (data.code !== 'Ok' || !data.routes.length) throw new Error('No route found');
  const route = data.routes[0];
  return {
    geometry: route.geometry,
    duration: Math.round(route.duration / 60),
    distance: (route.distance / 1609.34).toFixed(1),
  };
}

export default function ThingsToDo() {
  const [activeNum, setActiveNum] = useState(null);
  const [activeFilter, setActiveFilter] = useState(null); // null = All
  const [leafletReady, setLeafletReady] = useState(!!window.L);
  const cardRefs = useRef({});

  // Controls & directions state
  const [mobileControlsOpen, setMobileControlsOpen] = useState(true);
  const [fromNum, setFromNum] = useState('');
  const [toNum, setToNum] = useState('');
  const [routeInfo, setRouteInfo] = useState(null);
  const [routeLoading, setRouteLoading] = useState(false);
  const [routeError, setRouteError] = useState(null);

  useLeaflet(() => setLeafletReady(true));

  const handleMarkerClick = (num) => {
    setActiveNum(num);
    // Only scroll to card on desktop
    if (window.innerWidth > 768) {
      const el = cardRefs.current[num];
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const handleCardClick = (item) => {
    if (!item.coords) return;
    if (routeInfo) {
      handleClearRoute();
      setActiveNum(item.num);
    } else {
      setActiveNum(prev => (prev === item.num ? null : item.num));
    }
  };

  const handleGetRoute = async () => {
    if (!fromNum || !toNum || fromNum === toNum) return;
    const fromItem = MAP_ITEMS.find(i => i.num === Number(fromNum));
    const toItem = MAP_ITEMS.find(i => i.num === Number(toNum));
    if (!fromItem || !toItem) return;

    setRouteLoading(true);
    setRouteError(null);
    setRouteInfo(null);
    try {
      const info = await fetchOSRMRoute(fromItem.coords, toItem.coords);
      setRouteInfo(info);
    } catch (err) {
      setRouteError('Could not calculate route. Try opening in Google Maps.');
    }
    setRouteLoading(false);
  };

  const handleClearRoute = () => {
    setFromNum('');
    setToNum('');
    setRouteInfo(null);
    setRouteError(null);
  };

  const fromItem = fromNum ? MAP_ITEMS.find(i => i.num === Number(fromNum)) : null;
  const toItem = toNum ? MAP_ITEMS.find(i => i.num === Number(toNum)) : null;
  const googleMapsUrl = fromItem && toItem
    ? `https://www.google.com/maps/dir/?api=1&origin=${fromItem.coords[0]},${fromItem.coords[1]}&destination=${toItem.coords[0]},${toItem.coords[1]}&travelmode=driving`
    : null;

  return (
    <div className="site-wrapper">
      <div className="rsvp-bg-photo" style={{ backgroundImage: "url('/SunsetBar.png')" }} />
      <div className="rsvp-bg-overlay" />

      <div className="page-content" style={{ position: 'relative', zIndex: 2 }}>
        <div style={{ maxWidth: '860px', margin: '0 auto', padding: '40px 40px 0' }}>
          <h2 style={{
            fontFamily: 'var(--font-script)',
            fontSize: '60px',
            fontWeight: 400,
            color: 'var(--green-dark)',
            textAlign: 'center',
            marginBottom: '8px',
            lineHeight: 1.2,
          }}>Things to Do</h2>
          <p className="things-intro" style={{ textAlign: 'center', marginBottom: '24px', maxWidth: 'none', fontWeight: 600, fontSize: '1rem', color: 'grey' }}>
            Some of our favorite spots around Naples.
          </p>
        </div>

        <div className="things-split">

          {/* ── Scrollable list ── */}
          <div className="things-list-pane" style={{ paddingTop: '24px' }}>
            {CATEGORIES.map(cat => (
              <div className="things-category" key={cat.title}>
                <div className="things-category-header">
                  <h3>{cat.title}</h3>
                </div>
                <div className="things-grid">
                  {cat.items.map(item => (
                    <div
                      key={item.num}
                      className={`things-card${activeNum === item.num ? ' things-card--active' : ''}`}
                      ref={el => { cardRefs.current[item.num] = el; }}
                      onClick={() => handleCardClick(item)}
                      style={{ cursor: item.coords ? 'pointer' : 'default', '--cat-color': cat.color }}
                    >
                      <div className="things-card-top">
                        {item.coords && (
                          <span className="things-pin-badge" style={{ background: cat.color }}>
                            {item.num}
                          </span>
                        )}
                        <h4>{item.name}</h4>
                      </div>
                      <p>{item.desc}</p>
                      <div className="things-card-footer">
                        <a
                          className="things-card-address"
                          href={`https://maps.google.com/?q=${encodeURIComponent(item.address)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={e => e.stopPropagation()}
                        >
                          📍 {item.address}
                        </a>
                        {item.url && (
                          <a
                            className="things-card-link"
                            href={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={e => e.stopPropagation()}
                          >
                            Visit Website →
                          </a>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* ── Sticky map ── */}
          <div className="things-map-pane">

            {/* Controls card: filter + directions */}
            <div className="things-controls-card">
              <button
                className="things-controls-toggle"
                onClick={() => setMobileControlsOpen(prev => !prev)}
              >
                <span>Explore the Map</span>
                <span className={`directions-chevron${mobileControlsOpen ? ' directions-chevron--open' : ''}`}>▾</span>
              </button>
              {mobileControlsOpen && <div className="things-controls-body">
              <div className="things-filter-mobile">
                <select
                  className="things-filter-select"
                  value={activeFilter || ''}
                  onChange={e => { const val = e.target.value || null; setActiveFilter(val); setActiveNum(null); }}
                >
                  <option value="">All Categories</option>
                  {FILTER_OPTIONS.map(opt => (
                    <option key={opt.key} value={opt.key}>{opt.label}</option>
                  ))}
                </select>
              </div>
              <div className="things-controls-divider" />
              <div className="things-controls-directions">
                <span className="things-controls-dir-label">Get Directions</span>
                <div className="directions-selects">
                  <select
                    className="directions-select"
                    value={fromNum}
                    onChange={e => { setFromNum(e.target.value); setRouteInfo(null); setRouteError(null); }}
                  >
                    <option value="">From...</option>
                    {CATEGORIES.map(cat => (
                      <optgroup key={cat.title} label={cat.title}>
                        {cat.items.filter(i => i.coords).map(item => (
                          <option key={item.num} value={item.num} disabled={String(item.num) === toNum}>
                            {item.num}. {item.name}
                          </option>
                        ))}
                      </optgroup>
                    ))}
                  </select>
                  <select
                    className="directions-select"
                    value={toNum}
                    onChange={e => { setToNum(e.target.value); setRouteInfo(null); setRouteError(null); }}
                  >
                    <option value="">To...</option>
                    {CATEGORIES.map(cat => (
                      <optgroup key={cat.title} label={cat.title}>
                        {cat.items.filter(i => i.coords).map(item => (
                          <option key={item.num} value={item.num} disabled={String(item.num) === fromNum}>
                            {item.num}. {item.name}
                          </option>
                        ))}
                      </optgroup>
                    ))}
                  </select>
                </div>
                <div className="directions-actions">
                  <button
                    className="directions-go-btn"
                    onClick={handleGetRoute}
                    disabled={!fromNum || !toNum || fromNum === toNum || routeLoading}
                  >
                    {routeLoading ? 'Calculating...' : 'Go'}
                  </button>
                  {(routeInfo || routeError || fromNum || toNum) && (
                    <button className="directions-clear-btn" onClick={handleClearRoute}>Clear</button>
                  )}
                </div>
                {routeInfo && (
                  <div className="directions-result">
                    <span className="directions-result-time">~{routeInfo.duration} min</span>
                    <span className="directions-result-label">est. drive time</span>
                    {googleMapsUrl && (
                      <a
                        className="directions-gmaps-link"
                        href={googleMapsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Current Drive Time →
                      </a>
                    )}
                  </div>
                )}
                {routeError && (
                  <div className="directions-error">
                    {routeError}
                    {googleMapsUrl && (
                      <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer">
                        Open in Google Maps →
                      </a>
                    )}
                  </div>
                )}
              </div>
              </div>}
            </div>

            {/* Map container */}
            <div className="things-map-container">
              {leafletReady
                ? <NaplesMap
                    activeNum={activeNum}
                    onMarkerClick={handleMarkerClick}
                    activeFilter={activeFilter}
                    routeGeometry={routeInfo ? routeInfo.geometry : null}
                    routeEndpoints={routeInfo && fromNum && toNum ? [Number(fromNum), Number(toNum)] : null}
                  />
                : <div className="things-map-loading">Loading map…</div>
              }

              {/* Overlay card when marker is selected */}
              {activeNum && (() => {
                const item = MAP_ITEMS.find(i => i.num === activeNum);
                if (!item) return null;
                return (
                  <div className="things-map-overlay-card">
                    <button className="things-map-overlay-close" onClick={() => setActiveNum(null)}>✕</button>
                    <div className="things-map-overlay-header">
                      <span className="things-pin-badge" style={{ background: item.color }}>{item.num}</span>
                      <h4>{item.name}</h4>
                    </div>
                    <p>{item.desc}</p>
                    <div className="things-map-overlay-links">
                      <a
                        href={`https://maps.google.com/?q=${encodeURIComponent(item.address)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        📍 {item.address}
                      </a>
                      {item.url && (
                        <a href={item.url} target="_blank" rel="noopener noreferrer">
                          Visit Website →
                        </a>
                      )}
                    </div>
                  </div>
                );
              })()}
            </div>

          </div>

        </div>
      </div>
      <Footer />
    </div>
  );
}
